// "I'm free" (docs/SPEC.md item 10): how long it lasts, and the pill's time text. Port of web/profile-ui.js; same as
// ios FreeMode. On the web it only changes how pushy the phone's alerts are; the state syncs with the profile.
import { SHARED } from "../shared/config";
import { RULES } from "../shared/rules";
import type { FreeState } from "./model";

export interface FreeLength { id: string; title: string }

/** The lengths (nowish.json freeLengths), in order. */
export const freeLengths = (): readonly FreeLength[] => SHARED.freeLengths;

/** Until when (ms) a length lasts from `now`: a number of hours, the end of today (3am), or null = until turned off. */
export function freeUntil(lengthId: string, now: Date): number | null {
  const l = SHARED.freeLengths.find((x) => x.id === lengthId);
  if (!l) throw new Error(`no free length "${lengthId}" in nowish.json`);
  if (l.id === "endOfDay") return +RULES.endOfToday(now);
  if (l.hours == null) return null;
  return +now + l.hours * 3600e3;
}

/** The pill's time: "until 3am", "2h 10m", "until off". End of day (or anything 4h+ away) reads as a clock time; shorter ones count down. */
export function freeRemainingText(free: FreeState, lengthId: string | null, now: Date): string {
  if (free.until == null) return "until off";
  const mins = Math.max(Math.ceil((free.until - +now) / 60e3), 0);
  if (lengthId === "endOfDay" || mins >= 240) return `until ${RULES.timeString(new Date(free.until))}`;
  if (mins < 60) return `${mins}m`;
  return mins % 60 ? `${Math.floor(mins / 60)}h ${mins % 60}m` : `${Math.floor(mins / 60)}h`;
}
